import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'

export type PaginationDotProps = {
    color: 'onyx' | 'pearl' | 'keshi-3'
    spacingRight?: boolean
}

const PaginationDot: FunctionComponent<PaginationDotProps> = ({ color, spacingRight }) => (
    <Grid
        noExpand
        borderRadius={3.5}
        width={7}
        height={7}
        backgroundColor={color}
        marginRight={spacingRight ? 3 : 0}
    />
)

export default PaginationDot
